import { render, staticRenderFns } from "./FontGroupsTable.vue?vue&type=template&id=6841b85c&"
import script from "./FontGroupsTable.vue?vue&type=script&lang=ts&"
export * from "./FontGroupsTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports